import { apiCall } from "../helpers/api";

export const news_feed = (params = {}) => dispatch => {
    params.path = params.path || "news_feed";
    // params.method = params.method || "GET";

    return dispatch(apiCall(params));
}